import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Partner.css';
import partner1 from './img/partner1.png';
import partner2 from './img/partner2.png';
import partner3 from './img/partner3.png';
import partner4 from './img/partner4.png';

const PARTNER_TYPES = [
  {
    title: 'Reseller & Channel Partner',
    desc: 'Bring Bltz AI security to your customer base. We provide sales enablement, deal registration, competitive intelligence, and generous margin structures.',
    img: partner1,
    role: 'Reseller / Channel Partner',
  },
  {
    title: 'Technology Partner',
    desc: 'Integrate Bltz runtime protection directly into your platform. Joint go-to-market, co-branded content, and shared roadmap influence.',
    img: partner2,
    role: 'Technology / ISV Partner',
  },
  {
    title: 'MSSP & MDR Partner',
    desc: 'Add AI security monitoring to your managed service portfolio. Multi-tenant console, API-first architecture, and white-label options.',
    img: partner3,
    role: 'MSSP / MDR Provider',
  },
  {
    title: 'System Integrator & Consulting',
    desc: 'Deliver AI governance and compliance engagements with Bltz. Training, certification, and referral incentives for your practice.',
    img: partner4,
    role: 'System Integrator / Consulting',
  },
];

const BENEFITS = [
  { title: 'Revenue Growth', desc: 'Competitive margins, deal registration protection, and recurring revenue on subscriptions.' },
  { title: 'Technical Enablement', desc: 'Dedicated SE support, sandbox environments, and joint solution architecture.' },
  { title: 'Go-to-Market Support', desc: 'Co-branded campaigns, event sponsorship, and lead sharing programs.' },
  { title: 'Partner Portal', desc: 'Self-serve deal registration, training, collateral, and pipeline visibility.' },
];

const Partner = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">Partner with Bltz AI</h1>
      </section>

      <section className="ptn-content">
        <div className="ptn-intro">
          <h2 className="ptn-heading">Grow Your Business with AI Security</h2>
          <p className="ptn-subheading">
            The AI security market is projected to reach $60B by 2028. Join the Bltz partner ecosystem
            and help enterprises discover, protect, and govern their AI — while building a high-growth
            revenue stream for your business.
          </p>
        </div>

        <div className="ptn-partner-login-row">
          <button className="ptn-become-partner-btn" onClick={() => { navigate('/partner/apply'); window.scrollTo(0, 0); }}>
            Become a Partner
          </button>
          <button className="ptn-partner-login-btn" onClick={() => { navigate('/partner/login'); window.scrollTo(0, 0); }}>
            Partner Login
          </button>
        </div>

        <div className="ptn-types">
          {PARTNER_TYPES.map((pt) => (
            <div
              className="ptn-type-card"
              key={pt.title}
              style={{ backgroundImage: `url(${pt.img})`, cursor: 'pointer' }}
              onClick={() => { navigate(`/partner/apply?type=${encodeURIComponent(pt.role)}`); window.scrollTo(0, 0); }}
            >
              <div className="ptn-type-overlay"></div>
              <svg className="ptn-type-link-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <h3>{pt.title}</h3>
              <p>{pt.desc}</p>
            </div>
          ))}
        </div>

        <div className="ptn-benefits">
          <h2 className="ptn-heading">Why Partner with Bltz?</h2>
          <div className="ptn-benefit-grid">
            {BENEFITS.map((b) => (
              <div className="ptn-benefit-card" key={b.title}>
                <h4>{b.title}</h4>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="ptn-cta">
          <h2 className="ptn-heading">Ready to Get Started?</h2>
          <p className="ptn-subheading">
            Tell us about your business and how you'd like to partner. Our team will be in touch within one business day.
          </p>
          <button className="ptn-apply-btn" onClick={() => { navigate('/partner/apply'); window.scrollTo(0, 0); }}>
            Become a Partner &rarr;
          </button>
        </div>
      </section>
    </>
  );
};

export default Partner;
